export enum ECompanyTabs {
  COMPANIES = 'COMPANIES',
  FISHFARMS = 'FISHFARMS',
  GROUP = 'GROUP',
  VESSELS = 'VESSELS'
}
